/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-30 18:01:19
 * @LastEditors: linxi
 * @LastEditTime: 2021-07-12 18:06:23
 */
import { Request } from "./request";

export interface HealthPrisonAnaylseParams {
  osId?: number;
  scope?: number;
}

export interface DataParams {
  dType: number;
  osIds?: string;
  scope?: number;
}

export interface HealthPrisonContrastParams {
  osIds?: string;
  scope?: number;
}

//监管数据变化-卫健委(局)
export function getHealthPrisonContrast(
  params: HealthPrisonAnaylseParams
): Request {
  return {
    url: `/api/analysis/org/supervise/change`,
    method: "GET",
    params,
  };
}

// 监管数据对比 - 卫健委(局)
export function getDataAnaylse(params: DataParams): Request {
  return {
    url: `/api/analysis/org/supervise/compare`,
    method: "GET",
    params,
  };
}

// 监管数据占比 - 卫健委(局)
export function getHealthPrisonAnaylse(
  params: HealthPrisonContrastParams
): Request {
  return {
    url: `/api/analysis/org/supervise/percentage`,
    method: "GET",
    params,
  };
}
